import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';
import _ from 'lodash';

export function TextFieldSetting({ settings, itemConfiguration, setItemConfiguration }: any) {
  const [value, setValue] = useState(_.get(itemConfiguration, settings.configurationKey, ''));

  const updateValue = (value: string) => {
    setValue(value);
    setItemConfiguration((prevItemConfiguration: any) => {
      return {
        ...prevItemConfiguration,
        [settings.configurationKey]: value,
      };
    });
  };
  return (
    <Box>
      <TextField value={value} variant="outlined" fullWidth onChange={e => updateValue(e.target.value)} />
    </Box>
  );
}
